import {
  Stack,
  TextField,
  Button,
  Container,
  Typography,
  Paper,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  LinearProgress,
  FormControl,
  Autocomplete,
  Collapse,
  Snackbar,
  Alert,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import moment from "moment";
import numeral from 'numeral';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import LockResetIcon from '@mui/icons-material/LockReset';
import React, { useEffect, useState } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import styled from '@emotion/styled';
import 'jspdf-autotable';
import { ReactComponent as MastersIcon } from '../media/filter.svg';
import axios from '../axiosConfig';






function OBStatusReport() {

  const StyledTableCell = styled(TableCell)({
    color: 'white',
    fontWeight: '800',
    backgroundColor: '#219C90',
    padding: 'none',
    whiteSpace: 'nowrap',
  });

  const StyledTableCell2 = styled(TableCell)({
    color: '#006769',
    fontWeight: '800',
    backgroundColor: '#EEEDEB',
    padding: 'none',
    whiteSpace: 'nowrap',
    // textAlign:'center'
  });

  // Set the initial state for fromDate and toDate
  const formatDateToinitialValues = (date) => {
    if (!date) {
      return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  // Get the current date and 30 days before the current date
  const currentDate = new Date();
  const fromDateOnCurrentMonth = new Date(currentDate);
  fromDateOnCurrentMonth.setDate(1);
  const initialFromDate = formatDateToinitialValues(fromDateOnCurrentMonth);
  const initialToDate = formatDateToinitialValues(currentDate);

  const currentYear = new Date().getFullYear();
  const selectedYears = Array.from({ length: 10 }, (_, i) => {
    const year = currentYear - i;
    return `${year}`;
  });
  // eslint-disable-next-line no-restricted-globals
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';
  const [fromDate, setfromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(initialToDate);

  const [selectedYear, setSelectedYear] = useState(selectedYears[0]);
  const [buyerData, setbuyerData] = useState([]);
  const [buyerSelected, setbuyerSelected] = useState({
    Buyer_Id: '0',
    Buyer_Name: 'All',
  });
  const [styleData, setstyleData] = useState([]);
  const [styleSelected, setStyleSelected] = useState({
    Srhid: '0',
    StyleDescription: 'All',
  });

  const [reportData, setreportData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const groupedPaymentsByName = {};

  const resetFilters = () => {
    setfromDate(initialFromDate);
    setToDate(initialToDate);
    setbuyerSelected({ Buyer_Id: '0', Buyer_Name: 'All' });
    setStyleSelected({
      Srhid: '0',
      StyleDescription: 'All',
    });
    setStatusvalue('All')
    setFilteredData([]);
  };

  // other states
  const [openLoader, setOpenLoader] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showNoResultsSnackbar, setShowNoResultsSnackbar] = useState(false);
  const noResultsMessage = 'No results found for the applied filters.';
  const [expanded, setExpanded] = React.useState(true);

  // pagination
  const totalRows = filteredData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const currentPage = Math.max(0, Math.min(page, totalPages - 1));

  // API Integration

  const Status = [
    { name: "All", value: "All" },
    { name: "Pending", value: "Pending" },
    { name: "Progress", value: "Progress" },
    { name: "Completed", value: "Completed" },
  ]
  const [Statusvalue, setStatusvalue] = useState("All")

  useEffect(() => {
    GetAllActiveBuyers();
    formatDateToinitialValues();
    // getAllStyles()
    getStyles(); 
   }, []);


  // const getAllStyles = async () => {
  //   setOpenLoader(true);
  //   try {
  //     const res = await axios.instance.get('/getAllDailyStyles', {
  //       headers: { Authorization: tokent, 'Content-Type': 'application/json' },
  //     });
  //     setstyleData(res.data);
  //     setOpenLoader(false);
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };
  
    const getStyles = async () => {
      setOpenLoader(true);
      try {
        const res = await axios.instance.get('/getStyles', {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        setstyleData(res.data);
        setOpenLoader(false);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  const handleselectedYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  // get all Active Buyer data
  const GetAllActiveBuyers = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveBuyers', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setbuyerData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  reportData.forEach((payment) => {
    const fullName = `${payment.FirstName} ${payment.LastName}`;
    if (!groupedPaymentsByName[fullName]) {
      groupedPaymentsByName[fullName] = [];
    }
    groupedPaymentsByName[fullName].push(payment);
  });

  const applyFilters = async () => {
    try {
      const res = await axios.instance.post(`/getobstatusReport`,
        {
          BuyerId: buyerSelected.Buyer_Id,
          FROMDate: fromDate,
          ToDate: toDate,
          Obheaderid: styleSelected.Srhid,
          Status: Statusvalue,
          // FiscalYear: sessionStorage.getItem('FiscalYear')
        },
        {

          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
      setFilteredData(res.data);
      setPage(0);
      setOpenLoader(false);
      setExpanded(false);
      if (res.data.length === 0) {
        setShowNoResultsSnackbar(true);
      } else {
        setShowNoResultsSnackbar(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };



  const handleCloseSnackbar = () => {
    setShowNoResultsSnackbar(false);
  };

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  const totals = filteredData.reduce((acc, curr) => {
    Object.keys(curr).forEach((key) => {
      if (key !== 'sno' && key !== 'Buyer_Name') {
        acc[key] = (acc[key] || 0) + curr[key];
      }
    });
    return acc;
  }, {});

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2, p: 1 }} elevation={3}>
        <Snackbar
          style={{ marginTop: '45px' }}
          open={showNoResultsSnackbar}
          autoHideDuration={4000}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          onClose={handleCloseSnackbar}
        >
          <Alert onClose={handleCloseSnackbar} severity="info" variant="filled" sx={{ width: '100%' }}>
            {noResultsMessage}
          </Alert>
        </Snackbar>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2} mb={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #134e5e, #71b280)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Operation Bulletin Status Report
            </Typography>
          </Typography>
        </Grid>

        {/* filters */}
        <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
          <Accordion
            expanded={expanded}
            onChange={handleExpansion}
            disableGutters
            sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#36BA98' }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderTop: 'none' }}
            >
              <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                <IconButton aria-label="ExpandMoreIcon" color="white">
                  <MastersIcon style={{ color: 'white', width: 24, height: 24 }} />
                </IconButton>
                <Typography
                  sx={{
                    color: '#36BA98',
                    '&.active': {
                      color: 'text.primary',
                      bgcolor: 'action.selected',
                      fontWeight: 'fontWeightBold',
                    },
                  }}
                  variant="h6"
                >
                  Filters
                </Typography>
              </Stack>
            </AccordionSummary>

            <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
              <Stack direction={'column'} justifyContent={'space-between'} spacing={2} my={1}>
                <Stack direction={{ sm: 'row', xs: 'column' }} spacing={1}>
                  <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                    <Grid item xs={12} md={6} lg={6}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          options={[{ StyleDescription: 'All', Srhid: '0' }, ...styleData]}
                          getOptionLabel={(obj) => obj.Srhid !== '0' ? `${obj.StyleDescription} - ${obj.StyleNumber}` : `${obj.StyleDescription} `}
                          isOptionEqualToValue={(option, value) => option.StyleDescription === value.StyleDescription}
                          renderInput={(params) => <TextField {...params} label="Style" />}
                          value={styleSelected}
                          onChange={(e, newValue) => {
                            setStyleSelected(newValue);
                          }}
                          clearText="Clear"
                          disableClearable
                        />
                      </FormControl>
                    </Grid>
                    <Grid item lg={3} md={6} xs={12}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          options={[{ Buyer_Name: 'All', Buyer_Id: '0' }, ...buyerData]}
                          getOptionLabel={(obj) => obj.Buyer_Name}
                          isOptionEqualToValue={(option, value) => option.Buyer_Name === value.Buyer_Name}
                          renderInput={(params) => <TextField {...params} label="Buyer" />}
                          value={buyerSelected}
                          onChange={(e, newValue) => {
                            setbuyerSelected(newValue);
                          }}
                          clearText="Clear"
                          disableClearable
                        />
                      </FormControl>
                    </Grid>
                    <Grid item lg={3} md={6} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="year-select-label">Status</InputLabel>
                        <Select
                          labelId="year-select-label"
                          id="year-select"

                          value={Statusvalue}

                          size="small"
                          label="Year"
                          onChange={(e) => {
                            setStatusvalue(e.target.value)
                          }}
                        >
                          {Status.map((year, index) => (
                            <MenuItem key={index} value={year.value}>
                              {year.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="From"
                        type="date"
                        value={fromDate}
                        min={'1000-01-01'}
                        max={'9999-12-31'}
                        onChange={(e) => {
                          if (e.target.value) setfromDate(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="To"
                        type="date"
                        value={toDate}
                        min={'1000-01-01'}
                        max={'9999-12-31'}
                        onChange={(e) => {
                          if (e.target.value) setToDate(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    {/* <Grid item lg={2} md={6} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="year-select-label">Year</InputLabel>
                        <Select
                          labelId="year-select-label"
                          id="year-select"
                          value={selectedYear}
                          size="small"
                          label="Year"
                          onChange={handleselectedYearChange}
                        >
                          {selectedYears.map((year) => (
                            <MenuItem key={year} value={year}>
                              {year}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid> */}

                    <Grid item xs={12} lg={6} md={6} >
                      <Stack direction={{ xs: 'row' }} spacing={1} justifyContent={'end'}>
                        <Stack direction={'row'} spacing={1}>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={applyFilters}
                            startIcon={<FilterAltIcon />}
                          >
                            Apply Filters
                          </Button>
                          <Button
                            variant="contained"
                            color="warning"
                            onClick={resetFilters}
                            startIcon={<LockResetIcon />}
                          >
                            reset
                          </Button>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
              </Stack>
            </AccordionDetails>
          </Accordion>
        </Stack>

        <Collapse in={filteredData.length > 0}>
          <>
            {/* table  */}
            <TableContainer sx={{ borderRadius: 1, backgroundColor: 'inherit' }} elevation={4} component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ padding: 'none' }}>
                    {/* <StyledTableCell align="center">S.No</StyledTableCell> */}
                    <StyledTableCell align="left">OB No</StyledTableCell>
                    <StyledTableCell align="center">OB Date</StyledTableCell>
                    <StyledTableCell align="center">Status</StyledTableCell>
                    <StyledTableCell align="center">Buyer</StyledTableCell>
                    <StyledTableCell align="center">Style Description & No</StyledTableCell>
                    <StyledTableCell align="center">Garment Description</StyledTableCell>
                    <StyledTableCell align="center">Delivery Date</StyledTableCell>
                    <StyledTableCell align="center">Order Qty</StyledTableCell>
                    <StyledTableCell align="center">Actual Qty</StyledTableCell>
                    <StyledTableCell align="center">Cost/Pcs</StyledTableCell>
                    <StyledTableCell align="center">Planned Days</StyledTableCell>
                    <StyledTableCell align="center">Actual Days</StyledTableCell>
                    <StyledTableCell align="center">Planned Cost</StyledTableCell>
                    <StyledTableCell align="center">Actual Cost</StyledTableCell>
                    <StyledTableCell align="center">Deviation</StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(rowsPerPage > 0
                    ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : filteredData
                  ).map((enq, index) => (
                    <TableRow key={index} hover>
                      {/* <TableCell
                        align="center"
                        padding="normal"
                        sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                      >
                        {enq.sno}
                      </TableCell> */}
                      <TableCell
                        align="left"
                        padding="normal"
                        sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                      >
                        {enq.ObNo}
                      </TableCell>
                      <TableCell
                        align="center"
                        padding="normal"
                        sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                      >
                        {moment(enq.ObDate).format('DD-MM-YYYY')}
                      </TableCell>
                      <TableCell
                        align="center"
                        padding="normal"
                        sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                      >
                        <span
                          style={{
                            color: `${enq.Status === 'Completed' ?
                              'Green' : enq.Status === 'Progress' ?
                                'Blue' : 'Red'}`,
                            fontWeight: 700
                          }}
                        >{enq.Status}</span>
                      </TableCell>
                      <TableCell
                        align="center"
                        padding="normal"
                        sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                      >
                        {enq.Buyer_Name}
                      </TableCell>
                      <TableCell
                        align="center"
                        padding="normal"
                        sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                      >
                        {enq.Style}
                      </TableCell>
                      <TableCell
                        align="center"
                        padding="normal"
                        sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                      >
                        {enq.Garment_Description}
                      </TableCell>
                       <TableCell
                        align="center"
                        padding="normal"
                        sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                      >
                       {enq.DeliveryDate ? moment(enq.DeliveryDate).format('DD-MM-YYYY') : 'N/A'}
                      </TableCell>
                      <TableCell
                        align="center"
                        padding="normal"
                        sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                      >
                        {enq.OrderQty}
                      </TableCell>
                      <TableCell
                        align="center"
                        padding="normal"
                        sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                      >
                        {enq.ActualQty}
                      </TableCell>
                      <TableCell
                        align="center"
                        padding="normal"
                        sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                      >
                        {enq.cmCost}
                      </TableCell>
                      <TableCell
                        align="center"
                        padding="normal"
                        sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                      >
                        {enq.PlannedDays}
                      </TableCell>
                      <TableCell
                        align="center"
                        padding="normal"
                        sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                      >
                        {enq.ActualDays}
                      </TableCell>
                      <TableCell
                        align="center"
                        padding="normal"
                        sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                      >
                        {numeral(enq.PlannedCost).format('0,0.00')}
                      </TableCell>
                      <TableCell
                        align="center"
                        padding="normal"
                        sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                      >
                        {numeral(enq.ActualCost).format('0,0.00')}
                      </TableCell>
                      <TableCell
                        align="center"
                        padding="normal"
                        sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                      >
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                          {enq.ActualCost === 0 ? (
                            0
                          ) : enq.Deviation > 0 ? (
                            <>
                              <ArrowDropUpIcon sx={{ color: 'green' }} />
                              <span style={{ marginLeft: '4px' }}>
                                {numeral(enq.Deviation).format('0,0.00')}
                              </span>
                            </>
                          ) : (
                            <>
                              <ArrowDropDownIcon sx={{ color: 'red' }} />
                              <span style={{ marginLeft: '4px' }}>
                                {numeral(Math.abs(enq.Deviation)).format('0,0.00')}
                              </span>
                            </>
                          )}
                        </span>
                      </TableCell>


                    </TableRow>
                  ))}

                </TableBody>
              </Table>
            </TableContainer>

            {/* pagination */}
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={currentPage} // Use the calculated currentPage value
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0); // Reset the page when rowsPerPage changes
              }}
              mt={2}
            />
          </>
        </Collapse>
      </Container>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>
    </>)
}

export default OBStatusReport